import HTTP from './axios';

const CovenantService = {
  all: () => HTTP.get('/covenants').then((response) => response.data),
};

export default CovenantService;
